import { render, staticRenderFns } from "./Separator.vue?vue&type=template&id=6662e188&scoped=true"
import script from "./Separator.vue?vue&type=script&lang=ts"
export * from "./Separator.vue?vue&type=script&lang=ts"
import style0 from "./Separator.vue?vue&type=style&index=0&id=6662e188&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6662e188",
  null
  
)

export default component.exports